<template>
  <div class="order">
    <div class="top-navbar">
      <div class="main-container">
        <div class="row">
          <div class="col-auto">            
            <router-link to="/" tag="button" class="top-navbar__back" typeof="submit">
              <i class="icon-angle-left"></i>
              {{ t('message["Home Page"]', 'Home Page') }}
            </router-link>
          </div>
          <div class="col-auto ml-auto">
            <button v-if="settings.call_a_waiter" @click="$emit('call-a-waiter')" class="btn btn-success mb-3"
              type="submit"  id="call-waiter-button">
              {{ t('message["Call a Waiter"]', 'Call a Waiter') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <div class="n-modal__inner" v-if="!submittedOrder.review">
      <div class="n-modal__cont">
        <div class="n-modal__title">{{ t('message["Order Summary"]', 'Order Summary') }}</div>
        <!-- <div class="n-modal__place"><i class="icon-place"></i> 856 Esta Underpass</div> -->
        <div class="total">
          <div class="total__name col-auto">{{ t('message["Total"]', 'Total') }}</div>
          <div class="total__price col-auto ml-auto">{{ submittedOrder.grand_total }} AED</div>
        </div>
      </div>
      <div class="separator">
        <div class="separator__inner"></div>
      </div>
      <div>
        <div class="n-modal__cont">
          <h4 class="header-title mb-3">{{ t('message["Review"]', 'Review') }}</h4>

            <div class="form-group">
              <textarea class="form-control" v-model="review" name="review" placeholder="Your review" rows="3"
                required="" spellcheck="false"></textarea>
            </div>
        </div>
        <button @click="submitReview" class="n-modal__submit">{{ t('message["Submit"]', 'Submit') }}</button>
      </div>
    </div>
    <successfull-order @submit="emptyCart" v-else />
  </div>
</template>

<script>
import language from '../../mixins/translate'
import { mapState, mapMutations } from 'vuex'
import SuccessfullOrder from './SuccessfullOrder'

  export default {
    components: {
      SuccessfullOrder
    },
    props: {
      settings: {
      type: Object,
      default: () => ({})
      },
    },
    name: 'SubmittedORder',
    mixins: [language],
    data() {
      return {
        review: ''
      }
    },
    computed: {
      ...mapState('cart', ['submittedOrder']),
    },
    methods: {
      ...mapMutations('cart', {
        emptyOrder: 'SET_EMPTY_SUBMITTED_ORDER'
      }),
      submitReview() {
        this.$emit('submit-review', this.review)
      },
      emptyCart() {
        this.emptyOrder()
      }
    }
  }
</script>
